import { CallHistoryNumberType } from '~api/business-owner/callHistory';

export enum MessengerFilterTabsNames {
	PRIMARY = 'Primary',
	UNREAD = 'Unread',
	ESCALATIONS = 'Escalations',
	OTHER = 'Other',
}

export enum MessengerTabsNames {
	Messages = 'Messages',
	Calls = 'Call Center',
	AssistSettings = 'Assist Settings',
	PopupEvents = 'Popup Events',
	Notifications = 'Notifications',
	NOTIFICATIONS_TEMPLATES = 'Notifications Templates',
}

export const enum MessengerMessageType {
	MARKETING = 'Marketing',
	TRANSACTIONAL = 'Transactional',

	/** @deprecated Use MessengerAiMessageType instead. We should leave it to be compatible with old implementation */
	ESCALATION = 'Escalation',
}

export const enum MessengerAiMessageType {
	SUPPORT = 'Support',
	ESCALATION = 'Escalation',
}

export const enum NotificationMedium {
	SMS = 'sms',
	EMAIL = 'email',
}

export const enum MessageDirection {
	INBOUND = 'Inbound',
	OUTBOUND = 'Outbound',
}

export enum WebsocketMessengerMessageType {
	CONVERSATION_READ = 'conversationRead',
	CONVERSATION_RESOLVED = 'conversationResolved',
	INBOUND_SMS = 'inboundSms',
	OUTBOUND_SMS = 'outboundSms',
	PING = 'ping',
	SMS_STATUS_CALLBACK = 'smsStatusCallback',
	RESEND_SMS = 'resendSms',
	MESSAGE_DELETED = 'messageDeleted',
}

export const enum MessengerQueryKeys {
	CONVERSATION = 'conversation',
	CONVERSATIONS_LIST = 'conversations-list',
	CUSTOMER_MESSAGES = 'customer-messages',
	MARK_CONVERSATION_AS_READ = 'mark-conversation-as-read',
	UPDATE_CONVERSATIONS_READ_STATUS = 'update-conversations-read-status',
	MARK_CONVERSATION_AS_RESOLVED = 'mark-conversation-as-resolved',
	SEND_SMS_MESSAGE = 'send-sms-message',
	UNREAD_CONVERSATIONS_COUNT = 'unread-conversations-count',
	ESCALATION_COUNT = 'escalation-count',
	CHAT_BOT_CONFIGURATION_STATUS = 'chat-bot-configuration-status',
	CALL_HISTORY_LIST = 'call-history-list',
	CALL_HISTORY_PAGINATED_LIST = 'call-history-paginated-list',
	CALL_HISTORY_DETAIL = 'call-history-detail',
	ASSIST_SETTINGS = 'assist-settings',
	STORE_ASSIST_SETTINGS = 'store-assist-settings',
	STORE_MACHINE_PRICES = 'store-machine-prices',
	INCOMING_MESSAGE_NOTIFICATION_MODE = 'incoming-message-notification-mode',
	BUSINESS_CONFIGURATION = 'business-configuration',
	NOTIFICATION_SETTINGS = 'notification-settings',
	NOTIFICATION_TEMPLATES = 'notification-templates',
	CHAT_BOT_CONVERSATION_STATUS = 'chat-bot-conversation-status',
	SEND_BULK_MESSAGE = 'send-bulk-message',
	MESSENGER_WEBHOOK_CONNECTION_URL = 'messenger-webhook-connection-url',
	MESSAGE_MEDIA = 'messenger-message-media',
	LINK_METADATA = 'messenger-link-metadata',
	REMOVE_MESSAGE = 'remove-message',
	REMOVE_MESSAGES = 'remove-messages',
	REMOVE_CUSTOMER_MESSAGES = 'remove-customer-messages',
	RESEND_MESSAGE = 'resend-message',
	TRANSLATE_MESSAGE = 'translate-message',
	AGENT_VOICES = 'agent-voices',
	AGENT_VOICE = 'agent-voice',
	ASSIST_CALLS_METRICS = 'assist-calls-metrics',
	RETELL_ASSIST_CALL_TASKS = 'retell-assist-call-tasks',
	SUPPORTED_BUSINESS_NOTIFICATION_LANGUAGES = 'supported-business-notification-languages',
	AGENT_SPEECH_SETTINGS = 'agent-speech-settings',
	TWILIO_REGISTRATION = 'twilio-registration',
	TWILIO_REGISTRATION_STATUS = 'twilio-registration-status',
	TWILIO_AVAILABLE_PHONE_NUMBERS = 'twilio-available-phone-numbers',
}

export const enum MessengerSendMessageFormField {
	CENTS_CUSTOMER_IDS = 'centsCustomerIds',
	MESSAGE_DETAILS = 'messageDetails',
	MEDIA = 'media',
	QUERY = 'query',
	SEARCH_TERM = 'searchTerm',
}
export const SUPPORT_LABEL = 'Cents Support';
export const CHAT_BOT_NAME = 'Assist AI';
export const PER_PAGE_SIZE_LIMIT = 50;
export const CHARACTERS_LEFT_TO_SHOW_LIMIT = 10;
export const ONE_MESSAGE_CHARACTERS_LIMIT = 160;
export const MESSENGER_DEFAULT_PAGE_NUMBER = 1;
export const MARK_CONVERSATION_AS_READ_DELAY_MS = 2000;
export const UPDATE_CHAT_BOT_STATUS_DELAY_MS = 2000;

/** Display label for which Assist number a call came in on, or which number a row shows. */
export const PHONE_NUMBER_TYPE_LABELS: Record<CallHistoryNumberType, string> = {
	[CallHistoryNumberType.MARKETING]: 'Marketing',
	[CallHistoryNumberType.TRANSACTIONAL]: 'Transactional',
};
